import { useMemo } from 'react';
import { useProfileV2 } from 'core/lib/Profile';
import { useUsersForCurrentUser } from 'core/lib/hooks/useUsersForCurrentUser';

type UseUsersUsersParams = {
  requireManageSubscriptions?: boolean;
};

const useUsersUsers = ({ requireManageSubscriptions = false }: UseUsersUsersParams) => {
  const { profile } = useProfileV2();

  const { data, isLoading } = useUsersForCurrentUser({
    userId: profile?.userId ?? undefined,
    requireManageSubscriptions,
  });

  const users = useMemo(
    () => data?.filter((user) => user.id !== profile?.userId),
    [data, profile?.userId],
  );

  return { users, loading: isLoading };
};

export default useUsersUsers;
